import script from "./SecurityCheck.vue?vue&type=script&lang=ts&setup=true"
export * from "./SecurityCheck.vue?vue&type=script&lang=ts&setup=true"

import "./SecurityCheck.vue?vue&type=style&index=0&id=695857e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-695857e1"]])

export default __exports__